import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, filter, take } from 'rxjs';
import { CustomCarousel } from '../simple-responsive-carousel/carousel.model';
import { mediaConfig } from '../../../default-media.config';
import { SimpleResponsiveCarouselComponent } from '../simple-responsive-carousel/simple-responsive-carousel.component';
import { DEVICE_SIZE } from '../../../../../../core/models/others.model';
import { GridCategoriesTitle } from './core/grid-categories.model';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerCarouselComponent, CmsService } from '@spartacus/core';
import { ToolsService } from '../../../../../../core/services/tools.service';
import { GridCategoriesService } from './core/grid-categories.service';

@Component({
  selector: 'simple-grid',
  templateUrl: './grid-categories.component.html',
  styleUrl: './grid-categories.component.scss',
  standalone: false,
})
export class GridCategoriesComponent extends SimpleResponsiveCarouselComponent implements OnInit {
  DEVICE_SIZE = DEVICE_SIZE;
  title$ = new BehaviorSubject<GridCategoriesTitle>({});

  showCarousel$ = new BehaviorSubject(true);
  carouselConfigWide: CustomCarousel = {
    value: [],
    showNavigators: true,
    showIndicators: true,
  };

  override carouselConfig$ = new BehaviorSubject<CustomCarousel>(this.carouselConfigWide);

  override responsiveOptions = [
    {
      breakpoint: mediaConfig.mediaFormats!['widescreen'].width?.toString() + 'px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: mediaConfig.mediaFormats!['desktop'].width?.toString() + 'px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: mediaConfig.mediaFormats!['tablet'].width?.toString() + 'px',
      numVisible: 2,
      numScroll: 2,
    },
    {
      breakpoint: mediaConfig.mediaFormats!['mobile'].width?.toString() + 'px',
      numVisible: 1,
      numScroll: 1,
    },
  ];

  constructor(
    _componentData: CmsComponentData<CmsBannerCarouselComponent>,
    _cmsService: CmsService,
    _toolsService: ToolsService,
    private gridCategoriesService: GridCategoriesService,
  ) {
    super(_componentData, _cmsService, _toolsService);
  }

  override ngOnInit(): void {
    this.getContent();
    this.updateCarouselConfig();
    this.getContainerContent();
  }

  override handlerResize() {
    this.updateMedias();
    this.updateCarouselConfig();
  }

  getContainerContent() {
    this.componentData.data$.subscribe((data: any) => {
      this.title$.next(this.gridCategoriesService.normalizeTitle(data));
      this.carouselConfigWide.autoplayInterval = data.rotateInterval || 5000;
    });
  }

  updateCarouselConfig() {
    const currentResponsiveConfig = this.getCurrentResponsiveConfig();
    const config = this.carouselConfigWide;

    this.currentBanner$
      .pipe(
        filter(banners => banners?.length > 0),
        take(1),
      )
      .subscribe(banners => {
        config.showNavigators = banners.length > currentResponsiveConfig.numVisible;
        config.showIndicators = banners.length > currentResponsiveConfig.numVisible;
        config.autoplayInterval = banners.length <= currentResponsiveConfig.numVisible ? 0 : config.autoplayInterval;

        this.setCarouselConfig(config);
      });
  }

  setCarouselConfig(config: CustomCarousel) {
    this.showCarousel$.next(false);
    this.carouselConfig$.next(config);

    setTimeout(() => {
      this.showCarousel$.next(true);
    }, 50);
  }
}
